module.exports = "/trader.jpg?fc2f25";